import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/gatorz-frame-specs.js';
import dividerPrimary from '../../../views/website/products/components/description/ui-modules/divider-primary/raw-html.js';
import accordionPrimary from '../../../views/website/products/components/description/ui-modules/accordion-primary/raw-html.js';

const frameSpecsImageUrl = 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a68d0f7e871c4391885fd.webp?w=1000';

const defaultContent = `
<p><strong>WARHAWK FRAME MEASUREMENTS</strong></p>
<p>&nbsp;</p>
<p>Frame width <strong>143mm</strong></p>
<p>&nbsp;</p>
<p>Lens height <strong>39mm</strong></p>
<p>&nbsp;</p>
<p>Lens width <strong>66mm</strong></p>
<p>&nbsp;</p>
<p>Bridge Width <strong>15mm</strong></p>
<p>&nbsp;</p>
<p>Temple length <strong>118mm</strong></p>
<p>&nbsp;</p>
<p>Base Curve <strong>8x4</strong></p>
`.trim();

const cardInnerHtml = `
<div data-attribute="container-gatorz" class="container-gatorz">
  <div
    data-use-custom-width-img="true"
    data-width-img="70"
    data-gap="32"
    data-center-y="true"
    data-attribute="wrap-card"
    class="wrap-card"
    style="--gap-card: 32px; --width-img: 70%"
  >
    <div data-attribute="left-card" data-order="2" class="left-card" style="--order-left: 2">
      <div data-attribute="wrap-content" class="wrap-content">
        ${defaultContent}
      </div>
    </div>
    <div data-attribute="right-card" data-order="1" class="right-card" style="--order-right: 1">
      <div class="wrap-img">
        <img
          data-attribute="card-image"
          src="${frameSpecsImageUrl}"
          alt="Warhawk frame specs"
        />
      </div>
    </div>
  </div>
</div>
`;

const accordionContentHtml = `
  <div class="accordion-collapsible-body" data-attribute="accordion-collapsible-body">
    <div class="accordion-collapsible-body__inner">
      ${cardInnerHtml}
    </div>
  </div>
`;

const accordionPrimaryHtml = accordionPrimary(accordionContentHtml, {
  open: false,
  title: '<h2><strong>FRAME SPECS</strong></h2>',
  backgroundColor: '#ffffff',
  color: '#000000',
  icon: {
    type: 'plus-minus',
    position: 'right',
    show: true,
  },
});

const dividerPrimaryHtml = dividerPrimary({
  show: true,
  maxWidth: 9999,
  height: 3,
  align: 'center',
  backgroundColor: '#C3C3C3',
});

const contentHtml = `
  <div class="container">
    <div class="wrap-gatorz-frame-specs" data-attribute="gatorz-frame-specs-content">
      ${accordionPrimaryHtml}
      ${dividerPrimaryHtml}
    </div>
  </div>
`;

export default containerFuild(contentHtml, css, {
  topPadding: true,
  bottomPadding: false,
});
